import { TokensMath } from '../../../Fct/plugins/tokensMath';
import createMulticallPlugin from './generic/createMulticallPlugin';
export var MultiMultiplier = createMulticallPlugin({
    plugin: TokensMath.getters.Multiply,
    protocol: 'KIROBO_MULTICALL',
    type: 'LIBRARY:VIEWONLY',
    method: 'multiCall',
    name: 'multiMultiplier',
    config: {
        params: [
            { key: 'methodParams.numerator', multicallKey: 'amount1', isPreview: true },
            { key: 'methodParams.decimals1', multicallKey: 'decimals1' },
            { key: 'methodParams.factor', multicallKey: 'amount2', isPreview: true },
            { key: 'methodParams.decimals2', multicallKey: 'decimals2' },
            { key: 'methodParams.decimalsOut', multicallKey: 'decimalsOut' },
        ],
        tupleName: 'muls',
    },
    addPluginOnInit: true,
    withPluginOutputs: true,
});
